import type { BankDetail } from './bank-detail.types'

interface BankDetailLinesProps {
  details?: BankDetail[]
  description: string | null
}

const linesOf = (
  details: BankDetail[] | undefined,
  description: string | null
): BankDetail[] => {
  if (details && details.length > 0) return details
  return description ? [{ label: null, value: description }] : []
}

/** A transaction row's bank wording: labeled lines when the API split it, else the raw text. */
export const BankDetailLines = ({
  details,
  description,
}: BankDetailLinesProps) => {
  const lines = linesOf(details, description)
  if (lines.length === 0) return null

  return (
    <span className="flex min-w-0 flex-col" title={description ?? undefined}>
      {lines.map((line) => (
        <span key={`${line.label ?? ''}:${line.value}`}>
          {line.label && (
            <span className="text-neutral-500">{line.label}: </span>
          )}
          <span>{line.value}</span>
        </span>
      ))}
    </span>
  )
}
